import { FunctionComponent, useState } from 'react'
import styles from './daycareList.module.scss'
import Title from '@/components/_custom/Title/title'
import { Role } from '@/types/Role'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import DaycaresTable from '../../../daycare/daycareList/DaycaresTable/daycaresTable'
import { useTranslation } from 'react-i18next'
import LinkDaycareDialog from './Dialog/linkDaycareDialog'
import moment from 'moment/moment'
import { Daycare } from '@/types/Daycare'

interface DaycareAdminListProps {
    role?: Role
    groupId: number
    daycares: Array<Daycare>
    refetchGroups: () => void
}

const DaycareAdminList: FunctionComponent<DaycareAdminListProps> = ({ role, groupId, daycares, refetchGroups }) => {
    const { t } = useTranslation()

    const [isLinkDaycareDialogOpen, setLinkDaycareDialogOpen] = useState(false)

    return (
        <div className={styles.Container}>
            <div className={styles.TitleAndButton}>
                <div className={styles.Title}>
                    <Title text={t('structureList')} />
                </div>
                {role === Role.cald && (
                    <>
                        <ButtonTextIcon
                            type={'add'}
                            onClick={() => setLinkDaycareDialogOpen(true)}
                            className={styles.Button}
                        />
                        {isLinkDaycareDialogOpen && (
                            <LinkDaycareDialog
                                open={isLinkDaycareDialogOpen}
                                handleClose={() => setLinkDaycareDialogOpen(false)}
                                daycares={daycares}
                                groupId={groupId}
                                refetchGroups={refetchGroups}
                            />
                        )}
                    </>
                )}
            </div>
            <DaycaresTable
                daycares={
                    daycares.length >= 1
                        ? [...daycares]
                              .map((daycare: Daycare) => ({
                                  ...daycare,
                                  formattedValidityEnd: daycare.validityEnd
                                      ? moment(daycare.validityEnd, 'DD-MM-YYYY').format('YYYY-MM-DD')
                                      : ''
                              }))
                              .sort((a: Daycare, b: Daycare) => a.city.localeCompare(b.city))
                        : []
                }
                role={role}
                refreshDaycares={refetchGroups}
                unlinkDaycare={true}
            />
        </div>
    )
}

export default DaycareAdminList
